// extracted by mini-css-extract-plugin
export default {"container":"BannerFile_container__nmw8B","title":"BannerFile_title__861zJ","image":"BannerFile_image__x4DMq"};